import React, {Component} from 'react';
import Select from "react-select";
import {Spinner} from "react-bootstrap";
import InputSpinner from "react-bootstrap-input-spinner";

class CreateOrderAddonComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOs: false,
            isAddon: false,
            isChosseProduct: false,
        }
    }

    changeAddonCpu = (num) => {
        this.props.changeAddonCpu(num);
    }

    changeAddonRam = (num) => {
        this.props.changeAddonRam(num);
    }

    changeAddonDisk = (num) => {
        this.props.changeAddonDisk(num);
    }

    render() {
        return (
            <>
                {/*Sản phẩm*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Chọn VPS</div>
                    <div className="col-md-8">
                        <Select
                            options={this.props.listVps}
                            onChange={ this.props.choosseVps() }
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder={'Chọn VPS'}
                        />
                    </div>
                </div>
                {/*Addon*/}
                <div className="row form-group mt-4">
                    {
                        this.props.isLoadingAddon ? (
                            <div className="text-center col-md-12">
                                <Spinner animation="grow" variant="primary" />
                                <Spinner animation="grow" variant="secondary" />
                                <Spinner animation="grow" variant="success" />
                                <Spinner animation="grow" variant="danger" />
                                <Spinner animation="grow" variant="warning" />
                                <Spinner animation="grow" variant="info" />
                            </div>
                        ) : (
                            <>
                                {
                                    this.props.isFormAddon ? (
                                        <>
                                            <div className="col-md-3" />
                                            <div className="col-md-8">
                                                <div className="form-group addon-product text-center">
                                                    <label htmlFor="addon" className="text-danger mb-2">Chọn gói Addon</label>
                                                    <div className="row">
                                                        <div className="col-md-4 addon text-center">
                                                            <label>CPU</label>
                                                            {
                                                                Object.keys(this.props.productAddonCpu).length ? (
                                                                    <>
                                                                        <InputSpinner
                                                                            type={'int'}
                                                                            precision={2}
                                                                            max={20}
                                                                            min={0}
                                                                            step={1}
                                                                            value={0}
                                                                            onChange={ (num) =>  this.changeAddonCpu(num) }
                                                                            variant={'dark'}
                                                                            // size="sm"
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                        <div className="col-md-4 addon text-center">
                                                            <label>RAM</label>
                                                            {
                                                                Object.keys(this.props.productAddonRam).length ? (
                                                                    <>
                                                                        <InputSpinner
                                                                            type={'int'}
                                                                            precision={2}
                                                                            max={20}
                                                                            min={0}
                                                                            step={1}
                                                                            value={0}
                                                                            onChange={ (num) =>  this.changeAddonRam(num) }
                                                                            variant={'dark'}
                                                                            // size="sm"
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                        <div className="col-md-4 addon text-center">
                                                            <label>DISK</label>
                                                            {
                                                                Object.keys(this.props.productAddonDisk).length ? (
                                                                    <>
                                                                        <InputSpinner
                                                                            type={'int'}
                                                                            precision={2}
                                                                            max={200}
                                                                            min={0}
                                                                            step={10}
                                                                            value={0}
                                                                            onChange={ (num) =>  this.changeAddonDisk(num) }
                                                                            variant={'dark'}
                                                                            // size="sm"
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )
                                }
                            </>
                        )
                    }
                </div>
                {/*  Trừ tiền tài khoản  */}
                {
                    this.props.status === 'Finish' ? (
                        <div className="row form-group mt-4">
                            <div className="col-md-3 text-right font-weight-bold">Trừ tiền tài khoản</div>
                            <div className="col-md-8">
                                <input type="checkbox" name="minusCredit" onChange={ this.changeInput } value={ this.props.minusCredit } />
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </>
        );
    }
}

export default CreateOrderAddonComponent;